export class FirebaseDocument<T> {
  id: string;
  data: T;

  constructor(id: string, data: T) {
    this.id = id;
    this.data = data;
  }
}



// WEBPACK FOOTER //
// ./src/common/models/FirebaseDocument.ts